const trimInsentJson = json => {
  let newContent = [];

  const contents = json.content;

  if (!contents || contents.length <= 0) {
    return json;
  }

  contents.forEach(para => {
    if (para.content && para.content.length > 0) {
      newContent.push(para);
    }
  });
  json.content = newContent;

  return json;
};

export default trimInsentJson;
